<template>
  <div class="top-emotions-card">
    <a-alert
        v-if="warning"
        type="warning"
        show-icon
        class="top-emotions-card__warning"
    >
      <template #message>
        <div class="top-emotions-card__warning-content">
          <p class="top-emotions-card__warning-text">
            <span class="top-emotions-card__warning-text-strong">
              {{ warning.text }}
            </span>
            <span> Рекомендуется: </span>
          </p>

          <ol
              v-if="warning.recommendations && warning.recommendations.length"
              class="top-emotions-card__recommendations"
          >
            <li
                v-for="recommendation in warning.recommendations"
                :key="recommendation"
            >
              {{ recommendation }}
            </li>
          </ol>
        </div>
      </template>
    </a-alert>

    <div class="top-emotions-card__list">
      <div
          v-for="(item, index) in normalizedItems"
          :key="item.title"
          class="top-emotions-card__row"
          :class="{ 'top-emotions-card__row--muted': index > 2 }"
      >
        <div class="top-emotions-card__name">
          <span>№ {{ index + 1 }}.</span>
          <span>{{ item.title }}</span>
        </div>

        <span
            class="top-emotions-card__change"
            :class="{
              'positive-change': item.trend === 'up',
              'negative-change': item.trend === 'down',
              'neutral-change': !['up', 'down'].includes(item.trend)
            }"
        >
          {{ getChangeText(item.score, item.trend) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'TopEmotionsCard',

  props: {
    warning: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const normalizedItems = computed(() => {
      return props.items.map((item) => {
        const score = Number(item.score)

        return {
          ...item,
          title: item?.title || '',
          trend: item?.trend || '',
          score: Number.isFinite(score) ? score : 0,
        }
      })
    })

    const getChangeText = (score, trend) => {
      if (trend === 'up') {
        return `↑ ${score}%`
      }

      if (trend === 'down') {
        return `↓ ${score}%`
      }

      return '–'
    }

    return {
      normalizedItems,
      getChangeText,
    }
  },
}
</script>

<style scoped lang="scss">
.top-emotions-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: start;
  justify-content: space-between;
}

:deep(.top-emotions-card__warning.ant-alert) {
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background: #FFF8E1;
}

:deep(.top-emotions-card__warning .ant-alert-icon) {
  margin-top: 3px;
  color: #FAAD14;
  font-size: 16px;
}

:deep(.top-emotions-card__warning .ant-alert-message) {
  color: rgba(0, 0, 0, 0.88);
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
}

.top-emotions-card__warning-content {
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.top-emotions-card__warning-text {
  margin: 0;
}

.top-emotions-card__warning-text-strong {
  font-weight: 600;
}

.top-emotions-warning-strong {
  font-weight: 600;
  margin-left: 4px;
}

.top-emotions-card__recommendations {
  margin: 2px 0 0;
  padding-left: 22px;
}

.top-emotions-card__recommendations li {
  margin: 0;
}

.top-emotions-card__list {
  display: flex;
  flex-direction: column;
}

.top-emotions-card__row {
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #EEF0F3;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.top-emotions-card__row:last-child {
  border-bottom: none;
}

.top-emotions-card__row:first-child {
  border-top: none;
}

.top-emotions-card__name {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
}

.top-emotions-card__row--muted .top-emotions-card__name  {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.65);
}

.top-emotions-card__change {
  flex: 0 0 auto;
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
}

.positive-change {
  color: var(--main-green);
}

.negative-change {
  color: #F55565;
}

.neutral-change {
  color: rgba(0, 0, 0, 0.45);
}

:deep(.top-emotions-card__warning.ant-alert) {
  align-items: flex-start;
}

:deep(.top-emotions-card__warning .ant-alert-content) {
  align-self: flex-start;
}

:deep(.top-emotions-card__warning .ant-alert-icon) {
  align-self: flex-start;
  margin-top: 2px;
}
</style>